import { Button, PageHeader } from 'components';
import { Form, Input, Row, Col } from 'antd';
import styles from './style.module.scss';
import { CheckOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import useCompanyDocumentCategory from '../useCompanyDocumentCategory';

const CompanyCategoryDocumentEdit = ({ isNew }) => {
  const { form, updateInProcess, handleCreateOrUpdate } =
    useCompanyDocumentCategory(false);
  const { t } = useTranslation();
  const onFinish = async (values) => {
    await handleCreateOrUpdate(values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const title = isNew
    ? t('CREARE CATEGORIE DOCUMENTI')
    : t('MODIFICA CATEGORIE DOCUMENTI');

  const handleCreate = () => {
    form.submit();
  };

  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <Form
          form={form}
          name='basic'
          wrapperCol={{
            span: 24,
          }}
          initialValues={{
            title: '',
          }}
          layout={'vertical'}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete='off'
        >
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item label={t('Titolo')} name='title'>
                <Input />
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <Row gutter={16}>
          <Col>
            <Button
              onClick={handleCreate}
              width={'150px'}
              big
              icon={<CheckOutlined />}
              loading={updateInProcess}
            >
              {t('Invia')}
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default CompanyCategoryDocumentEdit;
